"use client";
import { LiveSharePage } from "@highway/design-system";

export default function LiveShare() {
    return (
        <>
            <title>Cost of Waiting</title>
            <LiveSharePage
                tool="cow"
                baseUrl="cost-of-waiting"
                renderHeaderText={({ clientName }) => `Cost of Waiting for ${clientName}`}
                renderButtonText={({ isMeeting }) => (isMeeting ? "View report" : "View flyer")}
                hasReportRoute
            />
        </>
    );
}
